import { Component, EventEmitter, Output } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { finalize } from 'rxjs/operators';
import { Comentarios, ItemTip, User } from '../../app/interfaces';
import { LoginProvider } from '../../providers/login/login';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { ComentComponent } from '../coment/coment';

/**
 * Generated class for the ComentarComentarioComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'comentar-comentario',
  templateUrl: 'comentar-comentario.html'
})
export class ComentarComentarioComponent {

  @Output() actualizar = new EventEmitter<boolean>();

  comentario: Comentarios;
  itemTip: ItemTip;
  comentarioTexto: string;
  actualizarLista: boolean;
  user: User;
  // funcion:  ComentComponent;

  constructor(public navCtrl: NavController,
              public viewCtrl: ViewController,
              public toastCtrl: ToastController,
              private restApi: RestApiProvider,
              private _loginProvider: LoginProvider,
              // private funcion: ComentComponent,
              public navParams: NavParams) 
  {
    this.comentario = this.navParams.get('comentario');
    if (!this.comentario) {
      return;
    }
    this.itemTip = this.navParams.get('itemTip');
    if (!this.itemTip) {
      return;
    }
  }

  ionViewWillEnter() {
    this._loginProvider.user.subscribe((user: User) => {
      this.user = user;
    });
  }

  cancelar() {
    this.viewCtrl.dismiss();
  }

  postComentario(comentarioTexto: string) {
    if (!comentarioTexto) {
      return;
    }

    this.restApi.postComentariodeComentario(comentarioTexto, 
      this.comentario, this.user).pipe(
     finalize(() => {
       let actualizarLista = true;
      //  this.actualizar.emit(actualizarLista);
      //  this.funcion.actualizarListaComentarios();       
       this.cancelar();
     })).subscribe((response: any) => {
       if (response.success) {
         const toast = this.toastCtrl.create({
           message: 'Comentario publicado',
           duration: 2000
         });
         toast.present();
       }
     });

    this.comentarioTexto = '';
  }

}



// WEBPACK FOOTER //
// ./src/components/comentar-comentario/comentar-comentario.ts